import { render, staticRenderFns } from "./Login-OAuth2.vue?vue&type=template&id=07fed4d1&"
import script from "./Login-OAuth2.vue?vue&type=script&lang=js&"
export * from "./Login-OAuth2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports